import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {InsuredPersonDTO} from '../models/InsuredPersonDTO';
import {InsuredPersonWithDatesDTO} from '../models/InsuredPersonWithDatesDTO';
import {PayerDTO} from '../models/PayerDTO';

@Injectable({
  providedIn: 'root'
})
export class PayerService {
  private url = environment.baseUrl + '/payer';

  constructor(private httpClient: HttpClient) {
  }

  getListOfPayers(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<PayerDTO>> {
    return this.httpClient.post<PagedResponseDTO<PayerDTO>>(this.url + '/filter', pagedRequestDTO);
  }
}
